import React from 'react';
import useTheme from '../hooks/useTheme';

interface BadgeProps {
  status: 'LIVE' | 'COMING SOON';
  children?: React.ReactNode;
}

export const Badge: React.FC<BadgeProps> = ({ status, children }) => {
  const { theme } = useTheme();
  const isLive = status === 'LIVE';
  
  const style: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 12px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    backgroundColor: isLive ? theme.colors.green.g1 : theme.text.muted,
    color: isLive ? theme.text.primary : theme.background.default,
  };

  return (
    <span style={style}>
      {children || status}
    </span>
  );
};

